var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResetpassword(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 234.088,
    height: 234.088,
    viewBox: "0 0 234.088 234.088",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2003",
    "data-name": "Group 2003",
    transform: "translate(-12438.79 -193.429)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2002",
    "data-name": "Group 2002"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_215",
    "data-name": "Ellipse 215",
    cx: 117.044,
    cy: 117.044,
    r: 117.044,
    transform: "translate(12438.79 193.429)",
    fill: "#f77a23"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2001",
    "data-name": "Group 2001"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1995",
    "data-name": "Group 1995"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1994",
    "data-name": "Group 1994"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3933",
    "data-name": "Path 3933",
    d: "M12605.252,363.222h-98.836a22.306,22.306,0,0,1-22.306-22.3h0a22.306,22.306,0,0,1,22.306-22.306h98.837a22.306,22.306,0,0,1,22.3,22.306h0A22.306,22.306,0,0,1,12605.252,363.222Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2000",
    "data-name": "Group 2000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1996",
    "data-name": "Group 1996"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3934",
    "data-name": "Path 3934",
    d: "M12504.994,348.242l-2.245-3.5,6.258-3.828-6.258-3.829,2.245-3.5,6.037,3.5v-7.325h4.527v7.325l6.037-3.5,2.245,3.5-6.257,3.829,6.257,3.828-2.245,3.5-6.037-3.5v7.325h-4.527v-7.325Z",
    fill: "#3a4d63"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1997",
    "data-name": "Group 1997"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3935",
    "data-name": "Path 3935",
    d: "M12533.354,348.242l-2.245-3.5,6.258-3.828-6.258-3.829,2.245-3.5,6.037,3.5v-7.325h4.527v7.325l6.037-3.5,2.246,3.5-6.258,3.829,6.258,3.828-2.246,3.5-6.037-3.5v7.325h-4.527v-7.325Z",
    fill: "#3a4d63"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1998",
    "data-name": "Group 1998"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3936",
    "data-name": "Path 3936",
    d: "M12561.713,348.242l-2.245-3.5,6.257-3.828-6.257-3.829,2.245-3.5,6.037,3.5v-7.325h4.528v7.325l6.037-3.5,2.244,3.5-6.258,3.829,6.258,3.828-2.244,3.5-6.037-3.5v7.325h-4.528v-7.325Z",
    fill: "#3a4d63"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1999",
    "data-name": "Group 1999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3937",
    "data-name": "Path 3937",
    d: "M12590.072,348.242l-2.245-3.5,6.258-3.828-6.258-3.829,2.245-3.5,6.037,3.5v-7.325h4.527v7.325l6.037-3.5,2.245,3.5-6.257,3.829,6.257,3.828-2.245,3.5-6.037-3.5v7.325h-4.527v-7.325Z",
    fill: "#3a4d63"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_3938",
    "data-name": "Path 3938",
    d: "M12579.393,261.651h-.452v-8.234a22.587,22.587,0,0,0-45.174,0v8.234h-1.491a5.314,5.314,0,0,0-5.315,5.315V301a5.315,5.315,0,0,0,5.315,5.315h47.117a5.316,5.316,0,0,0,5.316-5.315V266.966A5.315,5.315,0,0,0,12579.393,261.651Zm-25.35,33.439-12.681-12.68,3.715-3.715,8.966,8.965,14.787-14.787,3.715,3.715Zm18.568-41.673v8.234H12540.1v-8.234h0a16.261,16.261,0,0,1,32.521,0Z",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetpassword);
export default __webpack_public_path__ + "static/media/Resetpassword.8f6f2fd001b257f74360af3700f4c06f.svg";
export { ForwardRef as ReactComponent };